import Cookies from "js-cookie";
import API from "./API";
import TenantAPI from "./TenantAPI";
import axios, { Method } from "axios";
import { ConvoMetadata } from "../api-hooks/comments/useCreateComment";

function tenantRequestWithUrlHeader(method: Method, url: string, data: any) {
  const finalToken =
    Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`) ||
    "undefined";

  return axios({
    method: method,
    url: window.GC_API_URL + url,
    data: data,
    headers: {
      "X-Browser-Url": window.location.pathname + window.location.search,
      Authorization: "Bearer " + finalToken,
      "app-id": "GrowthCloud",
    },
    withCredentials: true,
  });
}

export default class CommentsAPI {
  static async createComment(payload: any, convoMetadata: ConvoMetadata) {
    return tenantRequestWithUrlHeader("post", "/tenant/comments/", {
      payload,
      convoMetadata,
    });
  }

  static async fetchComments(
    context: string,
    contextID: string,
    pageNumber: number,
    readNotifications: boolean
  ) {
    return API._bearerRequest(
      "post",
      `/tenant/comments/fetch`,
      { payload: { context, contextID, pageNumber, readNotifications } },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async reactToComment(commentID: string, reaction: string) {
    return API._bearerRequest(
      "put",
      `/tenant/comments/${commentID}/react`,
      { payload: { reaction } },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteComment(commentID: string) {
    return API._bearerRequest(
      "delete",
      `/tenant/comments/${commentID}/delete`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async editComment(
    commentID: string,
    comment: any,
    mentionedUsers: string[]
  ) {
    return tenantRequestWithUrlHeader(
      "put",
      `/tenant/comments/${commentID}/edit`,
      {
        payload: { comment, mentionedUsers },
      }
    );
  }

  static async updateNotifications(
    context: string,
    contextID: string,
    addSubscriber?: boolean
  ) {
    return API._bearerRequest(
      "put",
      "/tenant/comments/notifications",
      {
        payload: {
          context,
          contextID,
          ...(addSubscriber !== undefined && { addSubscriber }),
        },
      },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
